<h2 mat-dialog-title>
    <span *ngIf="!newTemplate && !isDuplicate">Edit Description</span>
    <span *ngIf="newTemplate && !isDuplicate">Add New Version</span>
    <span *ngIf="isDuplicate">Duplicate Version</span>
</h2>
<mat-dialog-content>
    <div style="width:400px;">
        <tyl-form-field style="width:100%;" label="Description"
            hint="{{50 - (description ? description.length : 0)}} characters left">
            <input matInput [(ngModel)]="description" maxlength="50" rows="1" style="resize:none"/>
        </tyl-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button *ngIf="!newTemplate" image="Checkmark.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button *ngIf="newTemplate" image="next arrow.png" label="Next" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>
